module.exports = __webpack_public_path__ + "img/ins-notes.fbd66996.svg";